module.exports = __webpack_public_path__ + "static/img/74-3.402228d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/74-3.jpg
// module id = Y7/a
// module chunks = 0